import React, { PureComponent } from 'react'
import { observer } from 'mobx-react'
import Modal from '../../../UniformComponents/Modal'
import './creationWizard.scss'

@observer
class CreationWizard extends PureComponent {
    render() {
        const { dashboardWizardStore } = this.props
        const {
            show, currentStage, stages, toggleShow, error,
        } = dashboardWizardStore
        if (error) {
            return (
                <Modal show={show} onClose={toggleShow} cssClass="dashboardCreationWizard">
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        There has been an unexpected error.
                        Please try again or contact your account manager for assistance.
                    </div>
                </Modal>
            )
        }
        return (
            <Modal show={show} onClose={toggleShow} cssClass={`dashboardCreationWizard ${stages[currentStage].modalClass || ''}`}>
                {
                    React.cloneElement(stages[currentStage].component,
                        { ...stages[currentStage].props, dashboardWizardStore })
                }
            </Modal>
        )
    }
}

export default CreationWizard
